import clsx from 'clsx';
import Link, { LinkProps } from 'next/link';
import styles from './NavLink.module.css';

interface NavLinkProps extends LinkProps {
  children: React.ReactNode;
  active?: boolean;
}

function NavLink(props: NavLinkProps) {
  const classes = clsx(styles.link, { [styles.active]: props.active });

  return (
    <Link href={props.href} className={classes}>
      {props.children}
      <div className={styles.underline} />
    </Link>
  );
}

export default NavLink;
